// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tag-action-container {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.tag-action-text {
  font-size: 14px;
}

.tag-rating-icon {
  margin-right: 8px;
}

.tag-rating-modal-paper {
  border-radius: 22px !important;
  overflow: hidden !important;
  width: 480px !important;
}

.tag-rating-modal-content {
  padding: 24px !important;
}

.tag-rating-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tag-rating-summary {
  display: flex;
  align-items: center;
  gap: 10px;
}

.tag-review-count {
  color: #7a7a7a;
  font-size: 16px;
}

.tag-close-btn {
  background: #f2f2f2 !important;
  width: 35px !important;
  height: 35px !important;
  outline: none !important;
}

.tag-divider {
  border-bottom: 1px solid #e2e2e2;
  margin-top: 18px;
  margin-bottom: 32px;
}

.tag-rating-title {
  text-align: center;
  font-size: 20px;
  font-weight: 500;
  color: #3f3f3f;
  margin-bottom: 28px;
}

.tag-star-selection {
  display: flex;
  justify-content: center;
  gap: 14px;
}

.tag-star-box {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: #c9c9c9;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.2s ease;
}

.tag-star-box.selected {
  background: #90b7ea;
}

.tag-star-icon {
  color: white !important;
  font-size: 34px !important;
}

.already-rated-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.already-rated-text {
  margin-bottom: 10px;
  font-size: 18px;
  color: #555;
}`, "",{"version":3,"sources":["webpack://./src/Utils/ReusuableTagActionModal/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb","sourcesContent":[".tag-action-container {\r\n  display: flex;\r\n  align-items: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.tag-action-text {\r\n  font-size: 14px;\r\n}\r\n\r\n.tag-rating-icon {\r\n  margin-right: 8px;\r\n}\r\n\r\n.tag-rating-modal-paper {\r\n  border-radius: 22px !important;\r\n  overflow: hidden !important;\r\n  width: 480px !important;\r\n}\r\n\r\n.tag-rating-modal-content {\r\n  padding: 24px !important;\r\n}\r\n\r\n.tag-rating-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.tag-rating-summary {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.tag-review-count {\r\n  color: #7a7a7a;\r\n  font-size: 16px;\r\n}\r\n\r\n.tag-close-btn {\r\n  background: #f2f2f2 !important;\r\n  width: 35px !important;\r\n  height: 35px !important;\r\n  outline: none !important;\r\n}\r\n\r\n.tag-divider {\r\n  border-bottom: 1px solid #e2e2e2;\r\n  margin-top: 18px;\r\n  margin-bottom: 32px;\r\n}\r\n\r\n.tag-rating-title {\r\n  text-align: center;\r\n  font-size: 20px;\r\n  font-weight: 500;\r\n  color: #3f3f3f;\r\n  margin-bottom: 28px;\r\n}\r\n\r\n.tag-star-selection {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 14px;\r\n}\r\n\r\n.tag-star-box {\r\n  width: 48px;\r\n  height: 48px;\r\n  border-radius: 12px;\r\n  background: #c9c9c9;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  transition: 0.2s ease;\r\n}\r\n\r\n.tag-star-box.selected {\r\n  background: #90b7ea;\r\n}\r\n\r\n.tag-star-icon {\r\n  color: white !important;\r\n  font-size: 34px !important;\r\n}\r\n\r\n.already-rated-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.already-rated-text {\r\n  margin-bottom: 10px;\r\n  font-size: 18px;\r\n  color: #555;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
